import { getModifiedPageData, getPageHtmlToSave } from './html';
import { getModifiedCss } from './css';
import { getModifiedScripts } from './scripts';
import { getParsedConfigs } from './configs';

export default {
	getModifiedPageData,
	getPageHtmlToSave,
	getModifiedCss,
	getModifiedScripts,
	getParsedConfigs,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/index.ts